import React from 'react';
import moment from 'moment';
import '../utility/styles/print.css';

const getCompanyDetails = () => {
  try {
    return JSON.parse(localStorage.getItem('companyDetails')) || {};
  } catch (error) {
    return {};
  }
};

const PrintItemWiseBooking = React.forwardRef((props, ref) => {
  const { data, details = [], selectedItem, firstDate, SecondDate } = props;
  const company = getCompanyDetails();
  const companyName =
    company.companyName ||
    company.company_name ||
    localStorage.getItem('company') ||
    'Company';
  const companyAddress = [
    company.address,
    company.city,
    company.state,
    company.pinCode || company.pin_code || company.pincode,
  ]
    .filter(Boolean)
    .join(', ');
  const companyContact = [
    company.mobile && `Phone: ${company.mobile}`,
    company.email && `Email: ${company.email}`,
  ]
    .filter(Boolean)
    .join('  •  ');
  const totalQuantity = data.reduce(
    (total, row) => total + (Number(row.QNTY) || 0),
    0
  );

  return (
    <div
      ref={ref}
      id="item-wise-booking-print"
      className="bill-summary-print"
    >
      <table className="bill-summary-print-table">
        <colgroup>
          <col style={{ width: '18%' }} />
          <col style={{ width: '57%' }} />
          <col style={{ width: '25%' }} />
        </colgroup>
        <thead>
          <tr>
            <th colSpan="3" className="print-company-header">
              <div className="print-company-name">{companyName}</div>
              {companyAddress && (
                <div className="print-company-detail">{companyAddress}</div>
              )}
              {companyContact && (
                <div className="print-company-detail">{companyContact}</div>
              )}
              <div className="print-report-heading">
                <span>Item Wise Booking</span>
                <span>
                  {moment(firstDate).format('DD MMM YYYY')} –{' '}
                  {moment(SecondDate).format('DD MMM YYYY')}
                </span>
              </div>
              <div className="print-report-meta">
                <span>{data.length} item type(s)</span>
                <span>{totalQuantity} total quantity</span>
              </div>
            </th>
          </tr>
          <tr className="print-column-header">
            <th>Item Code</th>
            <th>Item Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row.ICODE}-${index}`}>
              <td className="print-center">{row.ICODE || '—'}</td>
              <td>{row.ITEM_NAME || '—'}</td>
              <td className="print-amount">{Number(row.QNTY) || 0}</td>
            </tr>
          ))}
          <tr className="print-total-row">
            <td colSpan="2" className="print-total-label">
              Total Quantity
            </td>
            <td className="print-amount print-net">{totalQuantity}</td>
          </tr>
        </tbody>
      </table>

      {selectedItem && (
        <table
          className="bill-summary-print-table"
          style={{ marginTop: '18px' }}
        >
          <thead>
            <tr>
              <th colSpan="7" className="print-company-header">
                <div className="print-report-heading">
                  <span>Booking Details — {selectedItem.ITEM_NAME}</span>
                  <span>{details.length} booking(s)</span>
                </div>
              </th>
            </tr>
            <tr className="print-column-header">
              <th>Date</th>
              <th>Booking Order</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>Qnty</th>
              <th>Trial Date</th>
              <th>Delivery Date</th>
            </tr>
          </thead>
          <tbody>
            {details.map((row, index) => (
              <tr key={`${row.BOOKING_ORDER_NO}-${index}`}>
                <td className="print-center">
                  {row.DATE ? moment(row.DATE).format('DD-MM-YYYY') : '—'}
                </td>
                <td className="print-center">{row.BOOKING_ORDER_NO || '—'}</td>
                <td>{row.CUSTOMER_NAME || '—'}</td>
                <td className="print-center">{row.MOBILE || '—'}</td>
                <td className="print-amount">{Number(row.QNTY) || 0}</td>
                <td className="print-center">
                  {row.TRY_DATE
                    ? moment(row.TRY_DATE).format('DD-MM-YYYY')
                    : '—'}
                </td>
                <td className="print-center">
                  {row.DEL_DATE
                    ? moment(row.DEL_DATE).format('DD-MM-YYYY')
                    : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
});

export default PrintItemWiseBooking;
